import { render, staticRenderFns } from "./ClicDropdownDivider.vue?vue&type=template&id=8b361b70&scoped=true&"
import script from "./ClicDropdownDivider.vue?vue&type=script&lang=js&"
export * from "./ClicDropdownDivider.vue?vue&type=script&lang=js&"
import style0 from "./ClicDropdownDivider.vue?vue&type=style&index=0&id=8b361b70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b361b70",
  null
  
)

export default component.exports